<template>
    <ContainerWithMenu>
        <div class="page-content">
            Users
        </div>
    </ContainerWithMenu>
</template>

<script>
    import ContainerWithMenu from "../components/container/ContainerWithMenu";

    export default {
        name: "Users",
        components: { ContainerWithMenu }
    };
</script>
